import { connect } from 'react-redux';
import SGIP from './SGIP';

import {
    setSGIPValue,
    setSGIPToggle,
} from '../../common/sgip/actions';
import { selectSGIPIncentiveValue } from '../../common/sgip/selectors';


import { setSGIPIsVisible } from './actions';

const mapStateToProps = state => ({
    isLocked: state.isLockedUI.isLocked,
    isVisible: state.sgipUI.isVisible,
    sgipValue: state.sgip.sgipValue,
    sgipToggle: state.sgip.sgipToggle,
    sgipTotal: selectSGIPIncentiveValue(state),
    esskW: state.ess.esskW,
    setSGIPIsVisible,
    setSGIPToggle,
    setSGIPValue,
});

const combinedActions = {
    setSGIPIsVisible,
    setSGIPToggle,
    setSGIPValue,
};

export default connect(mapStateToProps, combinedActions)(SGIP);



// WEBPACK FOOTER //
// ./src/containers/Inputs/SGIP/index.js